<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" width="700px" :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
    <el-table v-loading="loading" :data="List" border :highlight-current-row="true">
      <el-table-column prop="fileName" :label="$t('AirFreight.FileName')" min-width="250" />
      <!-- <el-table-column prop="create" :label="$t('AirFreight.Creator')" width="100" />
      <el-table-column prop="createDT" :label="$t('AirFreight.CreationTime')" width="150" :formatter="formatterTime" /> -->
      <el-table-column prop="fileUrl" :label="$t('AirFreight.Operation')" width="120">
        <template slot-scope="scope">
          <div>
            <el-button type="text" size="small" @click="dfLoad(scope.row)">
              {{ $t('AirFreight.Download') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button type="crud" @click="closeDialog">{{ $t('AirFreight.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import dialog from '@/components/fms/mixins/dialog'
import { parseTime } from '@/utils/index'
import {
  GetAttachmentList,
  downloadApi,
  GetTokenByOss
} from '@/api/air/order/index'
export default {
  components: {},
  mixins: [dialog],
  props: {
    curRow: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      List: []
    }
  },
  computed: {},
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      const data = {
        jobNo: this.curRow.jobNo,
        loadType: ''
      }
      // 即是快件又是直单，优先快件
      if (this.curRow.jobType === 'AI') {
        data.loadType = '4'
      } else if (this.curRow.operateTypeCode === '快件') {
        data.loadType = '3'
      } else if (
        this.curRow.operateModeCode !== '直单' &&
        this.curRow.operateTypeCode !== '快件'
      ) {
        data.loadType = '2'
      } else if (this.curRow.operateModeCode === '直单') {
        data.loadType = '1'
      }
      this.loading = true
      const res = await GetAttachmentList(data)
      this.loading = false
      if (res && res.isSuccess) {
        this.List = res.data
      }
    },
    formatterTime(row, column) {
      return parseTime(row[column.property], '{y}-{m}-{d}')
    },
    dfLoad(row) {
      GetTokenByOss().then((res) => {
        if (res && res.data) {
          this.getBlob(downloadApi + '?id=' + row.ossId, res.data).then(
            (blob) => {
              this.DownloadItem(blob, row.fileName)
            }
          )
        }
      })
    },
    getBlob(url, token) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.setRequestHeader('Authorization', `Bearer ${token}`) // 添加授权头部
        xhr.onload = () => {
          if (xhr.status === 200) {
            const reader = new FileReader()
            reader.onload = (event) => {
              try {
                const content = this.decodeUnicode(
                  JSON.parse(event.target.result)
                )
                if (content.isSuccess === false) {
                  this.messagebox.alert(content.msg)
                } else {
                  resolve(xhr.response)
                }
              } catch (error) {
                resolve(xhr.response)
              }
            }
            reader.readAsText(xhr.response)
          }
        }
        xhr.onerror = () => {
          console.log('error：' + xhr.statusText)
        }
        xhr.send()
      })
    },
    DownloadItem(blob, fileName) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      link.click()
    },
    decodeUnicode(obj) {
      for (var key in obj) {
        if (typeof obj[key] === 'string') {
          obj[key] = unescape(obj[key].replace(/\\u/g, '%u'))
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.decodeUnicode(obj[key])
        }
      }
      return obj
    }
  }
}
</script>
<style scoped>
</style>
